var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WidgetWrapper',{attrs:{"is-collapsed":true,"is-active":!!_vm.campaign.is_contextual_target,"title":("" + (_vm.$t(
    'pages.campaignForm.tabs.targets.blocks.contextualTarget.title'
  )))},on:{"changeChecked":_vm.changeChecked}},[_c('div',{staticClass:"w-full flex justify-between items-center mt-8"},[_c('SelectChipsFromRightSlide',{attrs:{"chips-list":_vm.category,"chips-data":_vm.campaign.categories,"label":("" + (_vm.$t(
        'pages.campaignForm.tabs.targets.blocks.contextualTarget.category'
      )))},on:{"change":_vm.changeCategoryList}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }